import { Tooltip } from '@/components/primitives/Tooltip'
import {
  Alert,
  Box,
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
  Stack,
} from '@mui/material'
import { useTexts } from '../hooks/useTexts'
import { useAllowedTargetRanges, useOnChangeTargetRange, useTargetRange } from './ContextProvider'

export function Body() {
  const texts = useTexts()
  const value = useTargetRange()
  const onChangeTargetRange = useOnChangeTargetRange()
  const allowedTargetRanges = useAllowedTargetRanges()

  return (
    <Stack mb={1}>
      <RadioGroup
        value={value}
        onChange={event =>
          onChangeTargetRange(event.target.value as uui.domain.ui.forms.TargetRange)
        }
      >
        {allowedTargetRanges.ORDER.visible && (
          <Tooltip
            disabled={!allowedTargetRanges.ORDER.tooltip}
            title={allowedTargetRanges.ORDER.tooltip}
            placement="bottom"
          >
            <Stack>
              <FormControlLabel
                value="ORDER"
                control={<Radio />}
                label={texts.radio.order}
                disabled={allowedTargetRanges.ORDER.disabled}
              />
              {allowedTargetRanges.ORDER.helperText && (
                <Box ml={4} mb={1}>
                  <FormHelperText>{allowedTargetRanges.ORDER.helperText}</FormHelperText>
                </Box>
              )}
            </Stack>
          </Tooltip>
        )}
        {allowedTargetRanges.FUTURE.visible && (
          <Tooltip
            disabled={!allowedTargetRanges.FUTURE.tooltip}
            title={allowedTargetRanges.FUTURE.tooltip}
            placement="bottom"
          >
            <Stack>
              <FormControlLabel
                value="FUTURE"
                control={<Radio />}
                label={texts.radio.future}
                disabled={allowedTargetRanges.FUTURE.disabled}
              />
              {allowedTargetRanges.FUTURE.helperText && (
                <Box ml={4} mb={1}>
                  <FormHelperText>{allowedTargetRanges.FUTURE.helperText}</FormHelperText>
                </Box>
              )}
            </Stack>
          </Tooltip>
        )}
        {allowedTargetRanges.ALL.visible && (
          <Tooltip
            disabled={!allowedTargetRanges.ALL.tooltip}
            title={allowedTargetRanges.ALL.tooltip}
            placement="bottom"
          >
            <Stack>
              <FormControlLabel
                value="ALL"
                control={<Radio />}
                label={texts.radio.all.text}
                disabled={allowedTargetRanges.ALL.disabled}
              />
              {allowedTargetRanges.ALL.helperText && (
                <Box ml={4} mb={1}>
                  <FormHelperText>{allowedTargetRanges.ALL.helperText}</FormHelperText>
                </Box>
              )}
              {!allowedTargetRanges.ALL.disabled && (
                <Alert sx={{ marginLeft: 4 }} severity="warning">
                  {texts.radio.all.alert}
                </Alert>
              )}
            </Stack>
          </Tooltip>
        )}
      </RadioGroup>
    </Stack>
  )
}
